import React, { useMemo } from 'react';

import get from 'lodash/get';

import { Grid } from '@gogame/components';
import {
  FormField,
  useSiblingFieldName,
  withFormFieldGroupFormField,
} from '@gogame/form';

import {
  GENERAL,
  AFFECTED_LEVEL,
  SECONDARY_AFFECTED_LEVEL,
} from 'scenes/SmartRules/SmartRuleForm/General';
import {
  loadCreativeStatus,
  loadMetrics,
  loadOperators,
} from 'scenes/SmartRules/sources/fields';

import {
  CONDITION_TYPE,
  METRIC,
  OPERATOR,
  VALUE,
  PERIODS_COMPARE,
} from './constants';
import { METRIC_CREATIVE_STATUS } from './constants';
import { staticConditionValidationSchema } from './schemas';

export const StaticCondition = withFormFieldGroupFormField({
  validationSchema: staticConditionValidationSchema,
})(({ name, value, formik }) => {
  const getSiblingFieldName = useSiblingFieldName();

  const { [METRIC]: metricId, [OPERATOR]: operatorId } = value;

  const { [METRIC]: metric, [OPERATOR]: operator } =
    get(formik.hierarchyState, name) || {};

  const valueType = useMemo(() => {
    const valueType = metric?.data?.find(({ id }) => id === metricId)?.type;
    const operatorType = operator?.data?.find(
      ({ id }) => id === operatorId
    )?.type;

    return operatorType === PERIODS_COMPARE
      ? 'percent'
      : valueType?.toLowerCase();
  }, [metricId, operatorId, metric, operator]);

  const valueComponent = useMemo(() => {
    switch (valueType) {
      case METRIC_CREATIVE_STATUS:
        return (
          <FormField.Select
            label={'Value'}
            name={VALUE}
            source={loadCreativeStatus}
            active={Boolean(metricId && operatorId)}
            required={true}
            padding={0}
          />
        );
      default:
        return (
          <FormField.TextField
            label={'Value'}
            name={VALUE}
            type={valueType}
            disabled={!(metricId && operatorId)}
            required={true}
            padding={0}
          />
        );
    }
  }, [valueType, metricId, operatorId]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <FormField.Select
          label={'Metric'}
          name={METRIC}
          source={loadMetrics}
          groupBy={'category'}
          depends={[
            `${GENERAL}.${AFFECTED_LEVEL}`,
            `${GENERAL}.${SECONDARY_AFFECTED_LEVEL}`,
            getSiblingFieldName(CONDITION_TYPE),
          ]}
          required={true}
          lazy={true}
          padding={'0'}
        />
      </Grid>

      <Grid item xs={2}>
        <FormField.Select
          label={'Operator'}
          name={OPERATOR}
          source={loadOperators}
          depends={[
            `${GENERAL}.${AFFECTED_LEVEL}`,
            `${GENERAL}.${SECONDARY_AFFECTED_LEVEL}`,
            getSiblingFieldName(METRIC),
            getSiblingFieldName(CONDITION_TYPE),
          ]}
          active={Boolean(metricId)}
          required={true}
          lazy={true}
          padding={0}
        />
      </Grid>

      <Grid item xs={2}>
        {valueComponent}
      </Grid>
    </Grid>
  );
});
